var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKanban(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V7.5C2.5 7.96024 2.8731 8.33333 3.33333 8.33333H7.5C7.96024 8.33333 8.33333 7.96024 8.33333 7.5V3.33333C8.33333 2.8731 7.96024 2.5 7.5 2.5Z",
    stroke: "#42526E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 2.5H12.5003C12.0401 2.5 11.667 2.8731 11.667 3.33333V7.5C11.667 7.96024 12.0401 8.33333 12.5003 8.33333H16.667C17.1272 8.33333 17.5003 7.96024 17.5003 7.5V3.33333C17.5003 2.8731 17.1272 2.5 16.667 2.5Z",
    stroke: "#42526E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 11.666H12.5003C12.0401 11.666 11.667 12.0391 11.667 12.4993V16.666C11.667 17.1263 12.0401 17.4993 12.5003 17.4993H16.667C17.1272 17.4993 17.5003 17.1263 17.5003 16.666V12.4993C17.5003 12.0391 17.1272 11.666 16.667 11.666Z",
    stroke: "#42526E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.666H3.33333C2.8731 11.666 2.5 12.0391 2.5 12.4993V16.666C2.5 17.1263 2.8731 17.4993 3.33333 17.4993H7.5C7.96024 17.4993 8.33333 17.1263 8.33333 16.666V12.4993C8.33333 12.0391 7.96024 11.666 7.5 11.666Z",
    stroke: "#42526E",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanban);
export default __webpack_public_path__ + "static/media/kanban.3d0fef4b774fb12884ddc0bc9c70db7c.svg";
export { ForwardRef as ReactComponent };